<template>
  <tr>
    <td>{{ mentor.alumno.nombre }} {{ mentor.alumno.apellido }}</td>
    <td>{{ fecha(mentor.fecha_inicio) }}</td>
    <td><span :class="clase" class="mentoria-condicion">{{ mentor.condicion.nombre }}</span></td>
    <td>
      <div v-if="mentor.condiciones_mentoria_id == 2">
        <div v-if="mostrarPorFecha">
          <button @click="habilitarExamen(mentor.mentoria_id, servicio_id)" class="boton-habilitar-examen" v-if="mentor.habilitado_examen != 1 && this.cantidadInscriptos">Habilitar al Examen</button>
        </div>
        <span v-if="mentor.habilitado_examen == 1" class="boton-habilitar-examen-ok">Habilitado/a para el examen</span>
      </div>
    </td>
    <td class="botones_mesa_examen">
      <button @click="mostrarModalDatosMentoria()"  class="boton_editar_socio boton_pagos_lista icon-web tabla-link boton-mentoria"></button>
      <div class="contenedor_editar_password"
        v-if="mostrarDatosMentoria"
      >
        <div class="contenedor-datos-mentoria">
          <button class="cerrar_modal" @click="cerrarModalFinalizarMentoria()">X</button>
          <div class="contenedor-respuestas" ref="modalRef1">
            <p><span>&#8226;</span><b> Nombre del mentoreado</b></p>
            <p class="respuestas-mentoreado">{{ mentor.alumno.nombre }} {{ mentor.alumno.apellido }}</p>
            <p><span>&#8226;</span><b> ¿Hace cuanto toma clase de Yoga Iyengar?</b></p>
            <p class="respuestas-mentoreado">{{ mentor.tiempo_toma_clase }}</p>
            <p><span>&#8226;</span><b> ¿Hace cuanto toma clases con su mentor?</b></p>
            <p class="respuestas-mentoreado">{{ mentor.tiempo_toma_clase_mentor }}</p>
            <p><span>&#8226;</span><b> ¿Cuantas clases semanales toma?</b></p>
            <p class="respuestas-mentoreado">{{ mentor.cuantas_clases_semanales }}</p>
            <p><span>&#8226;</span><b> ¿Toma clases en formato online o presencial con el mentor?</b></p>
            <p class="respuestas-mentoreado">{{ mentor.formato_clase_mentor }}</p>
            <p><span>&#8226;</span><b> En caso de tomar clases regulares online con el mentor, ¿Toma clases presenciales con algún profesor certificado en su ciudad?</b></p>
            <p class="respuestas-mentoreado">{{ mentor.clases_presenciales_ciudad }}</p>
            <p><span>&#8226;</span><b> Si la respuesta fue no, especificar por qué (aclarar si no hay profesores certificados en el lugar de residencia del mentoreado)</b></p>
            <p class="respuestas-mentoreado">{{ mentor.porque_no }}</p>
            <p><span>&#8226;</span><b> ¿Cuantas clases semanles enseña?</b></p>
            <p class="respuestas-mentoreado">{{ mentor.cuantas_clases_dicta }}</p>
            <p><span>&#8226;</span><b> ¿Tiene una formación anterior? Especificar</b></p>
            <p class="respuestas-mentoreado">{{ mentor.formacion_anterior }}</p>
            <p><span>&#8226;</span><b> Observaciones y consideraciones sobre el mentoreado</b></p>
            <p class="respuestas-mentoreado">{{ mentor.observaciones }}</p>
          </div>
        </div>
      </div>
      <button @click="mostrarModalFinalizarMentoria()"  class="boton_editar_socio boton_pagos_lista icon-pencil-square-o tabla-link boton-mentoria"></button>
      <div class="contenedor_editar_password"
        v-if="mostrarFinalizarMentoria"
      >
        <div class="contenedor-form-finalizar-mentoria">
          <button class="cerrar_modal" @click="cerrarModalFinalizarMentoria()">X</button>
          <form
            action="#"
            @submit.prevent="finMentoriaAbierta(mentoria, mentor.mentoria_id)"
            class="form_editar_password"
            ref="modalRef1"
          >
            <div class="form_section_editar_password contenedor-ojo">
              <label for="fecha_finalizacion">Fecha de finalización</label>
              <input
                type="date"
                name="fecha_finalizacion"
                id="fecha_finalizacion"
                v-model="mentoria.fecha_finalizacion"
              >
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.fecha_finalizacion !== null"
              >
                {{ errores.fecha_finalizacion[0] }}
              </div>
            </div>
            <div class="form_section_editar_password contenedor-ojo">
              <label for="comentario_final_mentor">Observaciones</label>
              <textarea
                name="comentario_final_mentor"
                id="comentario_final_mentor"
                v-model="mentoria.comentario_final_mentor"
              ></textarea>
              <div
              class="form_mensaje_error_crear_mentor"
                v-if="errores.comentario_final_mentor !== null"
              >
                {{ errores.comentario_final_mentor[0] }}
              </div>
            </div>
            <button type="submit">Finalizar Mentoría</button>
          </form>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
// import examenService from '../services/examen'
// import BaseLoader4 from '../components/BaseLoader4.vue'
import mentorService from '../services/mentor'
export default {
  name: 'MentoriasAbiertasListaItem',
  components: {
    // BaseLoader4
  },
  props: ['mentor'],
  data: function () {
    return {
      clase: null,
      servicio_id: 32, // Cambiar
      cantidadInscriptos: false,
      mostrarFinalizarMentoria: false,
      mostrarDatosMentoria: false,
      mostrarPorFecha: true,
      mentoria: {
        fecha_finalizacion: null,
        comentario_final_mentor: null
      },
      errores: {
        fecha_finalizacion: null,
        comentario_final_mentor: null
      }
    }
  },
  methods: {
    fecha (fecha) {
      const year = fecha.slice(0, 4)
      const month = fecha.slice(5, 7)
      const day = fecha.slice(8, 10)
      return day + '/' + month + '/' + year
    },
    mostrarModalDatosMentoria () {
      console.log('eerrrr999')
      this.mostrarDatosMentoria = true
      document.addEventListener('mouseup', this.closeModalOnClickOutside)
      // Pongo el body sin scroll
      const body = document.body
      body.style.overflow = 'hidden'
    },
    mostrarModalFinalizarMentoria () {
      this.mostrarFinalizarMentoria = true
      document.addEventListener('mouseup', this.closeModalOnClickOutside)
      // Pongo el body sin scroll
      const body = document.body
      body.style.overflow = 'hidden'
    },
    closeModalOnClickOutside (event) {
      const modal = this.$refs.modalRef1
      console.log('aaaaaaa11111')
      console.log(modal)
      if (!modal.contains(event.target)) {
        console.log('wewewwewew')
        this.cerrarModalFinalizarMentoria()
      }
    },
    cerrarModalFinalizarMentoria () {
      console.log('222222')
      this.errores = {
        fecha_finalizacion: null,
        comentario_final_mentor: null
      }
      document.removeEventListener('mouseup', this.closeModalOnClickOutside)
      this.mostrarFinalizarMentoria = false
      this.mostrarDatosMentoria = false
      // this.errores2 = {
      //   password_nueva: null,
      //   password_nueva_confirmacion: null
      // }
      // this.mentoria = {
      //   fecha_finalizacion: null,
      //   comentario_final_mentor: null
      // }
      // saco el overflow del body
      const body = document.body
      body.style.overflow = 'auto'
    },
    finMentoriaAbierta (mentoria, id) {
      console.log(mentoria)
      console.log(id)
      mentorService
        .finMentoria(mentoria, id)
        .then(respuesta => {
          // this.cargando = false
          if (respuesta.success) {
            this.errores = {
              fecha_finalizacion: null,
              comentario_final_mentor: null
            }
            this.cerrarModalFinalizarMentoria()
            this.$emit('refrescar')
          } else {
            this.errores = {
              fecha_finalizacion: null,
              comentario_final_mentor: null,
              ...respuesta.errors
            }
          }
        })
    },
    habilitarExamen (mentoriaId, servicioId) {
      console.log(mentoriaId)
      console.log(servicioId)
      mentorService
        .habilitarExamen(mentoriaId, servicioId)
        .then(respuesta => {
          // this.cargando = false
          if (respuesta.success) {
            console.log('habilitado')
          } else {
            console.log('NO habilitado')
          }
          // mentorService
          //   .checkExamenesHabilitadosPorMentorId(this.mentor.mentor_id, this.servicio_id)
          //   .then(respuesta => {
          //     console.log('Cuantos Habilitados:', respuesta)
          //     if (respuesta.success) {
          //       this.cantidadInscriptos = true
          //     } else {
          //       this.cantidadInscriptos = false
          //     }
          //   })
          location.reload()
          // this.$emit('refrescar')
        })
    }
  },
  mounted: function () {
    // Date es MM/DD/YYYY
    if (new Date('09/09/2026') < new Date()) { // Saco la columna examen el dia 7 a la noche
      this.mostrarPorFecha = false
    }
    switch (this.mentor.condiciones_mentoria_id) {
      case 1:
        this.clase = 'mentoria-pendiente'
        break
      case 2:
        this.clase = 'mentoria-aceptada'
        break
      default:
        this.clase = 'mentoria-rechazada'
    }
    mentorService
      .checkExamenesHabilitadosPorMentorId(this.mentor.mentor_id, this.servicio_id)
      .then(respuesta => {
        console.log('Cuantos Habilitados:', respuesta)
        if (respuesta.success) {
          this.cantidadInscriptos = true
        } else {
          this.cantidadInscriptos = false
        }
      })
    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        this.cerrarModalFinalizarMentoria()
      }
    })
  }
}
</script>

<style>

</style>
